module.exports = __webpack_public_path__ + "9cc0f53e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/map_marker_van.png
// module id = 1680
// module chunks = 0